<script setup>
defineProps({
    // Shape from ExploreSponsorService: an absolute image URL (the banner is
    // uploaded to Cloudinary by an admin), alt text, and an optional CTA.
    sponsor: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <!-- Sponsored placement: admin-managed artwork in a translucent frame
         with an optional CTA (BH-61, edited at /admin/explore-sponsor). -->
    <div class="rounded-[10px] bg-white/20 p-[17px]">
        <div class="relative overflow-hidden rounded-[4px]">
            <img :src="sponsor.image_url" :alt="sponsor.alt" class="w-full" />
            <component
                :is="sponsor.cta?.url ? 'a' : 'div'"
                v-if="sponsor.cta?.label"
                :href="sponsor.cta?.url"
                class="absolute bottom-4 right-4 inline-flex items-center rounded-full bg-white px-7 py-2.5 font-brand text-[16px] font-semibold !text-brand-navy no-underline max-sm:hidden"
            >
                {{ sponsor.cta.label }}
            </component>
        </div>
    </div>
</template>
